import React from 'react';

import cn from 'classnames';

import PremiumButton from '../premium-button';
import classes from './styles.css';

type TPremiumButtonHeaderProps = {
    className?: string;
};

export const PremiumButtonHeader = ({ className }: TPremiumButtonHeaderProps) => {
    return (
        <div className={cn(classes.premiumButtonContainer, className)}>
            <PremiumButton />
        </div>
    );
};
